###
Variables related to the visual layout of the site.
CAUTION: DON'T DEPEND ON THIS FOR SSG CODE (THE VIEWPORT CANNOT BE KNOWN)
###

import dimensions from 'library/styles/vars/dimensions'

export state = ->
	bodyOffset: 0
	hideGlobalElements: false

export mutations =
	setBodyOffset: (state, offset) -> state.bodyOffset = offset
	setGlobalElementVisibility: (state, hide) ->
		state.hideGlobalElements = hide

export adjustBody = (store) ->
	bodyHeightOffset = 0

	interval = setInterval((->
		# Update bodyHeightOffset based on header height
		headerHeight = document.querySelector("header")?.offsetHeight
		if headerHeight
			bodyHeightOffset = parseInt(headerHeight)
		else
			bodyHeightOffset = 0

		if store.state.layout.bodyOffset != bodyHeightOffset
		then store.commit 'layout/setBodyOffset', offset: bodyHeightOffset

	), 500)
